import { useMemo } from 'react';
import type { AOEQuestionSchemaT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { AoeQuestionInput } from './AoeQuestionInput';
import { areRequiredQuestionsAnswered, type AoeAnswersById } from '../../model/aoeHelpers.js';

interface AoeFormProps {
  schema: AOEQuestionSchemaT;
  answersById: AoeAnswersById;
  onChange: (next: AoeAnswersById) => void;
}

export function AoeForm({ schema, answersById, onChange }: AoeFormProps) {
  const requiredComplete = useMemo(
    () => areRequiredQuestionsAnswered(schema, answersById),
    [answersById, schema]
  );

  return (
    <div className="space-y-4" aria-label="AOE questions">
      {schema.sections.map((section, index) => (
        <section
          key={`${section.title}:${section.questions[0]?.id ?? index}`}
          className="space-y-3"
        >
          <div>
            <div className="text-sm font-medium text-foreground">{section.title}</div>
            {section.description ? (
              <div className="mt-1 text-xs text-muted-foreground">{section.description}</div>
            ) : null}
          </div>

          <div className="space-y-3">
            {section.questions.map((q) => (
              <AoeQuestionInput
                key={q.id}
                question={q}
                value={answersById[q.id] ?? ''}
                onChange={(value) => {
                  onChange({ ...answersById, [q.id]: value });
                }}
              />
            ))}
          </div>
        </section>
      ))}

      <div className="text-xs text-muted-foreground">
        {requiredComplete
          ? 'All required questions are answered.'
          : 'Please answer all required questions.'}
      </div>
    </div>
  );
}
